/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_WaitingInputs */

const en_us2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your pose`)
};

const pt_br2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferindo a pose`)
};

const es_419_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisando tu pose`)
};

const pt_pt2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A verificar a pose`)
};

const fr_fr2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification de la pose`)
};

const de_de2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pose wird geprüft`)
};

const it_it2_body_assessment_pose_waiting = /** @type {(inputs: Body_Assessment_Pose_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo della posa`)
};

/**
* | output |
* | --- |
* | "Checking your pose" |
*
* @param {Body_Assessment_Pose_WaitingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_waiting = /** @type {((inputs?: Body_Assessment_Pose_WaitingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_WaitingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_waiting(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_waiting(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_waiting(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_waiting(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_waiting(inputs)
	return en_us2_body_assessment_pose_waiting(inputs)
});
export { body_assessment_pose_waiting as "body-assessment.pose_waiting" }